function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Resolver } from '@ovee.js/content-loader';
import gsap from 'gsap';
import { emitEvent } from 'ovee.js';

var LoadMoreResolver = /*#__PURE__*/function (_Resolver) {
  _inherits(LoadMoreResolver, _Resolver);

  var _super = _createSuper(LoadMoreResolver);

  function LoadMoreResolver() {
    var _this;

    _classCallCheck(this, LoadMoreResolver);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "shouldPushState", false);

    return _this;
  }

  _createClass(LoadMoreResolver, [{
    key: "contentOut",
    value: function contentOut() {
      var _this2 = this;

      this.container = this.target.closest('[data-load-container]');
      this.containerID = this.container.id;
      this.wrapper = this.container.querySelector('[data-load-items]');
      this.link = this.target;
      return new Promise(function (resolve) {
        _this2.container.classList.add('is-loading');

        resolve();
      });
    }
  }, {
    key: "updateContent",
    value: function updateContent(content) {
      var _this3 = this;

      return new Promise(function (resolve) {
        var _this3$wrapper;

        _this3.itemsParent = content;

        if (_this3.containerID) {
          _this3.itemsParent = content.querySelector("#".concat(_this3.containerID));
        }

        _this3.newContent = _this3.itemsParent.querySelectorAll('[data-load-item]');
        _this3.newLink = _this3.itemsParent.querySelector('[data-load-more]');
        gsap.set(_this3.newContent, {
          opacity: 0
        });

        (_this3$wrapper = _this3.wrapper).append.apply(_this3$wrapper, _toConsumableArray(_this3.newContent));

        if (_this3.newLink) {
          _this3.link.href = _this3.newLink.href;
          emitEvent(_this3.link, 'load-link-updated');
        } else {
          _this3.link.remove();
        }

        emitEvent(_this3.container, 'content-loaded');
        resolve();
      });
    }
  }, {
    key: "contentIn",
    value: function contentIn() {
      var _this4 = this;

      return new Promise(function (resolve) {
        _this4.container.classList.remove('is-loading');

        _this4.container.classList.add('has-loaded');

        gsap.to(_this4.newContent, {
          opacity: 1,
          duration: 0.75,
          ease: 'power1.out',
          onComplete: resolve
        });
      });
    }
  }]);

  return LoadMoreResolver;
}(Resolver);

export { LoadMoreResolver as default };